import React, { useRef, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Card, Container, Row, Col } from "react-bootstrap";
import { useSelector } from "react-redux";
import { selectProfile } from "../../store/slices/profile-slice";
import { selectRecentApplication } from "../../store/slices/application-slice";
import DpmLogo from "../Images/glowDPM.png";
import NNSeal from "../Images/navajo_nation_seal.png";
import "./Review.css";
import { jsPDF } from "jspdf";
import html2canvas from 'html2canvas';
import moment from "moment";
import prettyBytes from "pretty-bytes";
import { useNavigate } from "react-router-dom";
import {IoDocumentTextOutline} from "react-icons/io5";
import { IoIosPaper, IoIosSearch} from "react-icons/io";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCheckCircle} from "@fortawesome/free-solid-svg-icons";


const printDocument = async () => {
    const input = document.getElementById('contentToConvert');
    let pdf = new jsPDF('p', 'mm', 'a4');

    const canvas = await html2canvas(input);
    const pageHeight = 279;
    const pageWidth = 210;
    const leftMargin = 3;
    const rightMargin = 0;
    const bottomMargin = 3;
    const topMargin = 3;

    const imgWidth = (canvas.width * (pageWidth - leftMargin - rightMargin)) / canvas.width;
    const imgHeight = (canvas.height * imgWidth) / canvas.width;
    const heightOfContentPerPDFPage = pageHeight - topMargin - bottomMargin;

    let pdfPageHeightInPixels = canvas.height / (imgHeight / heightOfContentPerPDFPage);
    let startPx = 0;

    while (startPx < canvas.height) {
        let patchCanvas = document.createElement('canvas');
        patchCanvas.width = canvas.width;
        let patchHeight = Math.min(pdfPageHeightInPixels, canvas.height - startPx);
        patchCanvas.height = patchHeight;

        let context = patchCanvas.getContext('2d');
        context.drawImage(canvas, 0, startPx, canvas.width, patchHeight, 0, 0, canvas.width, patchHeight);

        pdf.addImage(patchCanvas.toDataURL('image/png'), 'PNG', leftMargin, topMargin, imgWidth, patchHeight / (canvas.width / imgWidth));

        if (startPx + patchCanvas.height < canvas.height) {
            pdf.addPage();
        }
        startPx += patchCanvas.height;
    }
    let currentDate = new Date();
    let dateString = currentDate.getFullYear() + '-' + (currentDate.getMonth() + 1) + '-' + currentDate.getDate();
    let fileName = 'completed-application-' + dateString + '.pdf';

    pdf.save(fileName);
};

export const Review = () => {
    const navigate = useNavigate();
    const application = useSelector(selectRecentApplication);
    const profile = useSelector(selectProfile);

    // Choose what to scroll to when loading in to the page
    const ref = useRef(null);

    // Extracts pathname property(key) from an object
    const { pathname } = useLocation();

    // Automatically scrolls to top whenever pathname changes
    useEffect(() => {
        ref.current?.scrollIntoView({ behavior: "smooth" });
    }, [pathname]);


    return (
        <>
            <Container className="pt-3 pb-3 mb-5 background justify-content-center rounded" ref={ref}>
                <Row>
                    <Col>

                        <Card className="card-style">
                            <Card.Body
                            >
                                <Row className="text-center">
                                    <h1 className="text-font">Great news - we&apos;ve received your application
                                        successfully!</h1>
                                    <FontAwesomeIcon icon={faCheckCircle} size="4x" color="green"/>
                                    <p className="mt-3">
                                        <h4 className="custom-h4">
                                            Please review the submitted details displayed below. If you notice any
                                            inaccuracies,
                                            please get in touch with the Department of Personnel Management promptly so
                                            you can
                                            resubmit your application with the correct information.
                                        </h4>
                                    </p>
                                </Row>
                            </Card.Body>
                        </Card>

                        <div className="d-flex flex-column flex-md-row">
                            <button className="btn btn-primary mb-3 me-2" onClick={printDocument}>
                                <IoDocumentTextOutline/> Download as PDF
                            </button>

                        </div>
                        <div id="contentToConvert">

                            <Card>
                                <Card.Body>


                                    <Card.Header className="bg-color">
                                        <Row className="text-center align-items-center">
                                            <Col xs={3} md={2}>
                                                <img src={DpmLogo} alt="Logo"
                                                     style={{maxWidth: '100%', float: 'left'}}/>
                                            </Col>
                                            <Col xs={6} md={8}>
                                                <h1 className='responsive-header'>Navajo Nation</h1>
                                                <h1 className='responsive-header'>Employment Application</h1>
                                            </Col>
                                            <Col xs={3} md={2}>
                                                <img src={NNSeal} alt="Logo"
                                                     style={{maxWidth: '70%', float: 'right'}}/>
                                            </Col>
                                        </Row>
                                    </Card.Header>
                                    <Container className="d-flex align-items-center py-1 bg-header">
                                        <h3 className="text-center w-100">Position Information</h3>
                                    </Container>

                                    <Row className="pt-3 mx-auto">
                                        <Col md={3} className="d-flex flex-column">
                                            <strong>App Date Recd:</strong>
                                            <span> {application?.App_Date_Recd || ''}</span>
                                        </Col>
                                        <Col md={3} className="d-flex flex-column">
                                            <strong>App REQID:</strong>
                                            <span> {application?.App_REQID || ''}</span>
                                        </Col>
                                        <Col md={3} className="d-flex flex-column">
                                            <strong>Position Number:</strong>
                                            <span> {application?.PositionNumber || ''}</span>
                                        </Col>
                                        <Col md={3} className="d-flex flex-column" style={{wordWrap: 'break-word'}}>
                                            <strong>Position Title:</strong>
                                            <span> {application?.PositionTitle || ''} </span>
                                        </Col>
                                    </Row>

                                    <Row className="pt-3 mx-auto">
                                        <Col md={3} className="d-flex flex-column">
                                            <strong>Location: </strong>
                                            <span>{application?.Location || ''} </span>
                                        </Col>
                                        <Col md={3} className="d-flex flex-column">
                                            <strong>Closing Date:</strong>
                                            <span> {application?.ClosingDate || ''}</span>
                                        </Col>
                                        <Col md={3} className="d-flex flex-column">
                                            <strong>Submission Date:</strong>
                                            <span> {application?.SubmissionDate || ''}</span>
                                        </Col>
                                        <Col md={3} className="d-flex flex-column" style={{wordWrap: 'break-word'}}>
                                            <strong>App Status:</strong>
                                            <span> {application?.App_Status || ''} </span>
                                        </Col>
                                    </Row>

                                    <Row className="pt-3 mx-auto">
                                        <Col md={3} className="d-flex flex-column">
                                            <strong>App Work Hours: </strong>
                                            <span>{application?.App_WorkHours || ''}</span>
                                        </Col>
                                        <Col md={3} className="d-flex flex-column">
                                            <strong>App Work Days:</strong>
                                            <span>  {application?.App_WorkDays || ''}</span>
                                        </Col>
                                        <Col md={3} className="d-flex flex-column">
                                            <strong> App Pay Rate:</strong>
                                            <span>  {application?.App_PayRate || ''}</span>
                                        </Col>
                                        <Col md={3} className="d-flex flex-column" style={{wordWrap: 'break-word'}}>
                                            <strong> App Employment Type:</strong>
                                            <span>  {application?.App_EmploymentType || ''} </span>
                                        </Col>
                                    </Row>

                                    <Row className="pt-3 mx-auto">
                                        <Col md={3} className="d-flex flex-column">
                                            <strong> App Sensitive:</strong>
                                            <span>{application?.App_Sensitive || ''}</span>
                                        </Col>
                                        <Col md={3} className="d-flex flex-column">
                                            <strong> App Department:</strong>
                                            <span>    {application?.App_Department || ''}</span>
                                        </Col>
                                        <Col md={3} className="d-flex flex-column">
                                            <strong> App Location:</strong>
                                            <span>   {application?.App_Location || ''}</span>
                                        </Col>

                                    </Row>


                                    <Container className="d-flex align-items-center py-1 bg-header mt-3">
                                        <h3 className="text-center w-100">Applicant Information</h3>
                                    </Container>
                                    <Row className="pt-3 mx-auto">
                                        <Col md={3} className="d-flex flex-column" style={{wordWrap: 'break-word'}}>
                                            <strong>Suffix:</strong>
                                            <span> {profile?.suffix || ''}</span>
                                        </Col>
                                        <Col md={3} className="d-flex flex-column">
                                            <strong>First Name:</strong>
                                            <span>{profile?.firstName || ''}</span>
                                        </Col>
                                        <Col md={3} className="d-flex flex-column">
                                            <strong>Middle Name:</strong>
                                            <span> {profile?.middleName || ''}</span>
                                        </Col>
                                        <Col md={3} className="d-flex flex-column">
                                            <strong>Last Name:</strong>
                                            <span> {profile?.lastName || ''}</span>
                                        </Col>

                                    </Row>
                                    <Row className="pt-3 mx-auto">
                                        <Col md={3} className="d-flex flex-column" style={{wordWrap: 'break-word'}}>
                                            <strong>Phone Number:</strong>
                                            <span> {profile?.phoneNumber || ''}  </span>
                                        </Col>
                                        <Col md={3} className="d-flex flex-column">
                                            <strong>dob: </strong>
                                            <span>{profile?.dob || ''}</span>
                                        </Col>
                                        <Col md={3} className="d-flex flex-column">
                                            <strong>Gender:</strong>
                                            <span>  {profile?.gender || ''} </span>
                                        </Col>
                                        <Col md={3} className="d-flex flex-column">
                                            <strong>Nationality:</strong>
                                            <span> {profile?.nationality || ''} </span>
                                        </Col>

                                    </Row>
                                    <Row className="pt-3 mx-auto">

                                        <Col md={3} className="d-flex flex-column">

                                            <strong> Address Line 1:</strong>
                                            <span>{profile?.addressLine1 || ''}</span>

                                        </Col>

                                        <Col md={3} className="d-flex flex-column">

                                            <strong> Navajo Tribe Member:</strong>
                                            <span>    {profile?.navajoTribeMember || ''}  </span>

                                        </Col>
                                        <Col md={3} className="d-flex flex-column">
                                            <strong>Census:</strong>
                                            <span> {profile?.census || ''}</span></Col>

                                    </Row>
                                    <Row className="pt-3 mx-auto">
                                        <Col md={3} className="d-flex flex-column" style={{wordWrap: 'break-word'}}>
                                            <strong> Address Line 2:</strong>
                                            <span>{profile?.addressLine2 || ''}</span>

                                        </Col>
                                        <Col md={3} className="d-flex flex-column">
                                            <strong>State:</strong>
                                            <span>{profile?.state || ''}</span>
                                        </Col>
                                        <Col md={3} className="d-flex flex-column">
                                            <strong>Zipcode:</strong>
                                            <span> {profile?.zipcode || ''}</span>
                                        </Col>
                                        <Col md={3} className="d-flex flex-column">
                                            <strong>City:</strong>
                                            <span> {profile?.city || ''} </span>
                                        </Col>

                                    </Row>

                                    {profile?.hasDriverLicense === 'Yes' ? (<>
                                        <Row className="pt-3 mx-auto">
                                            <Col md={3} className="d-flex flex-column" style={{wordWrap: 'break-word'}}>
                                                <strong> Has Driver License:</strong>
                                                <span>  {profile?.hasDriverLicense || ''} </span>
                                            </Col>
                                            <Col md={3} className="d-flex flex-column">
                                                <strong> Driver License Number:</strong>
                                                <span>  {profile?.driverLicenseNumber || ''}</span>
                                            </Col>
                                            <Col md={3} className="d-flex flex-column">
                                                <strong> Driver License Class:</strong>
                                                <span>  {profile?.driverLicenseClass || ''}</span>
                                            </Col>
                                            <Col md={3} className="d-flex flex-column">
                                                <strong> Driver License State:</strong>
                                                <span> {profile?.driverLicenseState || ''}</span>
                                            </Col>
                                        </Row>
                                        <Row className="pt-3 mx-auto">
                                            <Col md={3} className="d-flex flex-column" style={{wordWrap: 'break-word'}}>
                                                <strong> Driver License Expiration Date:</strong>
                                                <span>  {profile?.driverLicenseExpirationDate || ''} </span>
                                            </Col>
                                            <Col md={3} className="d-flex flex-column">
                                                <strong> Driver License Type:</strong>
                                                <span>  {profile?.driverLicenseType || ''}</span>
                                            </Col>

                                        </Row>
                                    </>) : (
                                        <div className="box-msg my-2">
                                            <Row className="pt-3 mx-auto">
                                                <Col md={3} className="flex-column word-wrap">
                                                    <strong> Has Driver License:</strong>
                                                    <span>  {profile?.hasDriverLicense || ''} </span>
                                                </Col>
                                                <Col md={9} className="flex-column pt-3 note">
                                                    <p>
                                                        Please Note: A driver&apos;s license may be required for certain
                                                        job
                                                        positions.
                                                    </p>
                                                </Col>
                                            </Row>
                                        </div>
                                    )}


                                    {profile?.NN_CIBForm_OriginalName && profile?.NN_CIBForm_UploadDate && profile?.NN_CIBForm_FileSize ?
                                        (<><Row className="pt-3 mx-auto">
                                            <Col md={3} className="d-flex flex-column" style={{wordWrap: 'break-word'}}>
                                                <strong> CIB Uploaded:</strong>
                                                <span> {"Yes"} </span>
                                            </Col>

                                            <Col md={6} className="d-flex flex-column" style={{wordWrap: 'break-word'}}>
                                                <strong> CIB File Upload:</strong>
                                                <span> {profile?.NN_CIBForm_OriginalName}{", "}{profile?.NN_CIBForm_UploadDate ? moment(profile?.NN_CIBForm_UploadDate).format('MMMM Do YYYY, h:mm:ss a, ') : ''}{prettyBytes(parseInt(profile?.NN_CIBForm_FileSize))} </span>
                                            </Col>
                                            <Col md={3} className="d-flex flex-column" style={{wordWrap: 'break-word'}}>
                                                <strong> Preference:</strong>
                                                <span>   <p
                                                    style={{color: '#008000'}}>Navajo Preference eligible</p> </span>
                                            </Col>

                                        </Row>


                                        </>)
                                        :
                                        (<>
                                            <div className="box-msg my-2">
                                                <Row className="pt-3 mx-auto">
                                                    <Col md={3} className="d-flex flex-column"
                                                         style={{wordWrap: 'break-word'}}>
                                                        <strong> CIB Uploaded:</strong>
                                                        <span> {"No"} </span>
                                                    </Col>
                                                    <Col md={9} className="d-flex flex-column"
                                                         style={{wordWrap: 'break-word'}}>

                                                <span> <p style={{color: 'red'}}>Please Note: To qualify for Navajo preference a
                                            valid CIB must be uploaded.</p></span>
                                                    </Col>

                                                </Row>
                                            </div>
                                        </>)
                                    }


                                    {profile?.RIF_Form_OriginalName && profile?.RIF_Form_UploadDate && profile?.RIF_Form_FileSize ?
                                        (
                                            <Row className="pt-3 mx-auto">
                                                <Col md={2} className="d-flex flex-column">
                                                    <strong> RIF: </strong>
                                                    <span> Yes </span>
                                                </Col>
                                                <Col md={6} className="d-flex flex-column"
                                                     style={{wordWrap: 'break-word'}}>
                                                    <strong> RIF File Upload:</strong>
                                                    <span>
                {profile?.RIF_Form_OriginalName},
                                                        {profile?.RIF_Form_UploadDate ? moment(profile?.RIF_Form_UploadDate).format('MMMM Do YYYY, h:mm:ss a, ') : ''}
                                                        {prettyBytes(parseInt(profile?.RIF_Form_FileSize))}
            </span>
                                                </Col>
                                                <Col md={2} className="d-flex flex-column"
                                                     style={{wordWrap: 'break-word'}}>
                                                    <strong> RIF Date:</strong>
                                                    <span> {profile?.rifDate || ''} </span>
                                                </Col>
                                                <Col md={2} className="d-flex flex-column"
                                                     style={{wordWrap: 'break-word'}}>
                                                    <strong> Preference:</strong>
                                                    <span>   <p
                                                        style={{color: '#008000'}}>RIF Preference eligible</p> </span>
                                                </Col>
                                            </Row>
                                        )
                                        :
                                        (
                                            <div className="box-msg my-2">
                                                <Row className="pt-3 mx-auto">
                                                    <Col md={3} className="d-flex flex-column"
                                                         style={{wordWrap: 'break-word'}}>
                                                        <strong> RIF Uploaded:</strong>
                                                        <span> No </span>
                                                    </Col>
                                                    <Col md={9} className="d-flex flex-column"
                                                         style={{wordWrap: 'break-word'}}>
                <span>
                    <p style={{color: 'red'}}>
                        Please Note: A valid RIF form must be uploaded.
                    </p>
                </span>
                                                    </Col>
                                                </Row>
                                            </div>
                                        )
                                    }
                                    {

                                        profile?.NN_Spouse &&
                                        profile?.NN_SpouseCIBForm_OriginalName &&
                                        profile?.NN_SpouseCIBForm_UploadDate &&
                                        profile?.NN_SpouseCIBForm_FileSize &&
                                        profile?.NN_SpouseMarriageLicenseForm_OriginalName &&
                                        profile?.NN_SpouseMarriageLicenseForm_UploadDate &&
                                        profile?.NN_SpouseMarriageLicenseForm_FileSize &&
                                        profile?.NN_Spouse_ResidenceVerificationForm_OriginalName &&
                                        profile?.NN_Spouse_ResidenceVerificationForm_UploadDate &&
                                        profile?.NN_Spouse_ResidenceVerificationForm_FileSize ?
                                            (
                                                <>
                                                    <Row className="pt-3 mx-auto">
                                                        <Col md={2} className="d-flex flex-column"
                                                             style={{wordWrap: 'break-word'}}>
                                                            <strong> NN Spouse:</strong>
                                                            <span> {profile?.NN_Spouse || ''} </span>
                                                        </Col>
                                                        <Col md={2} className="d-flex flex-column">
                                                            <strong> NN Residency Uploaded: </strong>
                                                            <span>  Yes</span>
                                                        </Col>

                                                        <Col md={2} className="d-flex flex-column">
                                                            <strong> Marriage License:</strong>
                                                            <span> Yes </span>
                                                        </Col>
                                                        <Col md={3} className="d-flex flex-column">
                                                            <strong>Spouse CIB Uploaded:</strong>
                                                            <span> Yes </span>
                                                        </Col>
                                                        <Col md={3} className="d-flex flex-column">
                                                            <strong> Preference:</strong>
                                                            <span>   <p
                                                                style={{color: '#008000'}}>NN Spouse eligible</p> </span>
                                                        </Col>

                                                    </Row>
                                                    <Row className="pt-3 mx-auto">
                                                        <Col md={6} className="d-flex flex-column"
                                                             style={{wordWrap: 'break-word'}}>
                                                            <strong> Spouse CIB File Upload:</strong>
                                                            <span>
        {profile?.NN_SpouseCIBForm_OriginalName},{" "}
                                                                {profile?.NN_SpouseCIBForm_UploadDate ? moment(profile?.NN_SpouseCIBForm_UploadDate).format('MMMM Do YYYY, h:mm:ss a, ') : ''}
                                                                {prettyBytes(parseInt(profile?.NN_SpouseCIBForm_FileSize))}
    </span>
                                                        </Col>

                                                    </Row>
                                                    <Row className="pt-3 mx-auto">
                                                        <Col md={6} className="d-flex flex-column"
                                                             style={{wordWrap: 'break-word'}}>
                                                            <strong> Spouse Marriage License Form Upload:</strong>
                                                            <span>
        {profile?.NN_SpouseMarriageLicenseForm_OriginalName},{" "}
                                                                {profile?.NN_SpouseMarriageLicenseForm_UploadDate ? moment(profile?.NN_SpouseMarriageLicenseForm_UploadDate).format('MMMM Do YYYY, h:mm:ss a, ') : ''}
                                                                {prettyBytes(parseInt(profile?.NN_SpouseMarriageLicenseForm_FileSize))}
    </span>
                                                        </Col>

                                                    </Row>
                                                    <Row className="pt-3 mx-auto">
                                                        <Col md={6} className="d-flex flex-column"
                                                             style={{wordWrap: 'break-word'}}>
                                                            <strong> Spouse Residence Verification Form Upload:</strong>
                                                            <span>
        {profile?.NN_Spouse_ResidenceVerificationForm_OriginalName},{" "}
                                                                {profile?.NN_Spouse_ResidenceVerificationForm_UploadDate ? moment(profile?.NN_Spouse_ResidenceVerificationForm_UploadDate).format('MMMM Do YYYY, h:mm:ss a, ') : ''},
                                                                {prettyBytes(parseInt(profile?.NN_Spouse_ResidenceVerificationForm_FileSize))}
    </span>
                                                        </Col>
                                                    </Row>
                                                </>
                                            )
                                            :
                                            (
                                                <div className="box-msg my-2">
                                                    <Row className="pt-3 mx-auto">
                                                        <Col md={3} className="d-flex flex-column"
                                                             style={{wordWrap: 'break-word'}}>
                                                            <strong> Spouse Information Uploaded:</strong>
                                                            <span> No </span>
                                                        </Col>
                                                        <Col md={9} className="d-flex flex-column"
                                                             style={{wordWrap: 'break-word'}}>
                                                            <p style={{color: 'red'}}>
                                                                Please Note: To qualify for Navajo Spouse preference,
                                                                all relevant data and forms must be uploaded.
                                                            </p>
                                                        </Col>
                                                    </Row>
                                                </div>
                                            )
                                    }


                                    {
                                        profile?.veteran &&
                                        profile?.DD214OnFile &&
                                        profile?.Veteran_DD214Form_OriginalName &&
                                        profile?.Veteran_DD214Form_UploadDate &&
                                        profile?.Veteran_DD214Form_FileSize &&
                                        profile?.Veteran_Preference_ApplicationForm_OriginalName &&
                                        profile?.Veteran_Preference_ApplicationForm_UploadDate &&
                                        profile?.Veteran_Preference_ApplicationForm_FileSize ?
                                            (
                                                <>
                                                    <Row className="pt-3 mx-auto">
                                                        <Col md={2} className="d-flex flex-column"
                                                             style={{wordWrap: 'break-word'}}>
                                                            <strong> Veteran:</strong>
                                                            <span>  {profile?.veteran || ''} </span>
                                                        </Col>
                                                        <Col md={3} className="d-flex flex-column">
                                                            <strong> DD 214 On File: </strong>
                                                            <span> {profile?.DD214OnFile || ''}</span>
                                                        </Col>
                                                        <Col md={4} className="d-flex flex-column"
                                                             style={{wordWrap: 'break-word'}}>
                                                            <strong> Veteran Preference Verification Upload:</strong>
                                                            <span>  Yes</span>
                                                        </Col>
                                                        <Col md={3} className="d-flex flex-column">
                                                            <strong> Preference:</strong>
                                                            <span>   <p
                                                                style={{color: '#008000'}}>Veteran Preference eligible</p> </span>
                                                        </Col>

                                                    </Row>

                                                    <Row className="pt-3 mx-auto">
                                                        <Col md={6} className="d-flex flex-column"
                                                             style={{wordWrap: 'break-word'}}>
                                                            <strong> Veteran DD214 Form Upload:</strong>
                                                            <span>
        {profile?.Veteran_DD214Form_OriginalName},{" "}
                                                                {profile?.Veteran_DD214Form_UploadDate ? moment(profile?.Veteran_DD214Form_UploadDate).format('MMMM Do YYYY, h:mm:ss a, ') : ''}
                                                                {prettyBytes(parseInt(profile?.Veteran_DD214Form_FileSize))}
    </span>
                                                        </Col>

                                                    </Row>
                                                    <Row className="pt-3 mx-auto">


                                                        <Col md={6} className="d-flex flex-column"
                                                             style={{wordWrap: 'break-word'}}>
                                                            <strong> Veteran Preference Application Upload:</strong>
                                                            <span>
        {profile?.Veteran_Preference_ApplicationForm_OriginalName},{" "}
                                                                {profile?.Veteran_Preference_ApplicationForm_UploadDate ? moment(profile?.Veteran_Preference_ApplicationForm_UploadDate).format('MMMM Do YYYY, h:mm:ss a, ') : ''}
                                                                {prettyBytes(parseInt(profile?.Veteran_Preference_ApplicationForm_FileSize))}
    </span>
                                                        </Col>

                                                    </Row>
                                                </>
                                            )
                                            :
                                            (
                                                <div className="box-msg my-2">
                                                    <Row className="pt-3 mx-auto">
                                                        <Col md={3} className="d-flex flex-column"
                                                             style={{wordWrap: 'break-word'}}>
                                                            <strong> Veteran Information Uploaded:</strong>
                                                            <span> No </span>
                                                        </Col>
                                                        <Col md={9} className="d-flex flex-column"
                                                             style={{wordWrap: 'break-word'}}>
                                                            <p style={{color: 'red'}}>
                                                                Please Note: To qualify for Veteran preference, all
                                                                relevant data and forms must be uploaded.
                                                            </p>
                                                        </Col>
                                                    </Row>
                                                </div>
                                            )
                                    }


                                    <Container className="d-flex align-items-center py-1 bg-header mt-3">
                                        <h3 className="text-center w-100">Education</h3>
                                    </Container>
                                    <Container className="mt-0 bg-body-tertiary d-inline-block">
                                        <h5 className="text-start w-100 text-muted">High School</h5>
                                    </Container>
                                    {
                                        profile?.attendedHighSchool === "Yes" ?
                                            <>
                                                <Row className="pt-1 mx-auto">
                                                    <Col md={3} className="d-flex flex-column"
                                                         style={{wordWrap: 'break-word'}}>
                                                        <strong> Attended High School:</strong>
                                                        <span> {profile?.attendedHighSchool} </span>
                                                    </Col>
                                                    <Col md={3} className="d-flex flex-column">
                                                        <strong> High School Start:</strong>
                                                        <span> {profile?.highSchoolStart} </span>
                                                    </Col>
                                                    <Col md={3} className="d-flex flex-column">
                                                        <strong> High School End: </strong>
                                                        <span> {profile?.highSchoolEnd}</span>
                                                    </Col>
                                                </Row>
                                                <Row className="pt-3 mx-auto">
                                                    <Col md={3} className="d-flex flex-column"
                                                         style={{wordWrap: 'break-word'}}>
                                                        <strong> High School Name: </strong>
                                                        <span> {profile?.highSchoolName} </span>
                                                    </Col>
                                                    <Col md={3} className="d-flex flex-column">
                                                        <strong> High School Address: </strong>
                                                        <span> {profile?.highSchoolAddress} </span>
                                                    </Col>
                                                    <Col md={3} className="d-flex flex-column">
                                                        <strong> Education: </strong>
                                                        <span> {profile?.education}</span>
                                                    </Col>
                                                </Row>
                                                <Row className="pt-3 mx-auto">
                                                    <Col md={6} className="d-flex flex-column"
                                                         style={{wordWrap: 'break-word'}}>
                                                        <strong> High School Form Upload:</strong>
                                                        <span>
                        {profile?.HS_Form_OriginalName ? profile?.HS_Form_OriginalName + ',' : ''}{" "}
                                                            {profile?.HS_Form_UploadDate ? moment(profile?.HS_Form_UploadDate).format('MMMM Do YYYY, h:mm:ss a, ') : ''}
                                                            {parseInt(profile?.HS_Form_FileSize) ? prettyBytes(parseInt(profile?.HS_Form_FileSize)) : 'No File Uploaded'}
                    </span>
                                                    </Col>
                                                </Row>
                                            </>

                                            :

                                            <Col md={3} className="d-flex flex-column"
                                                 style={{wordWrap: 'break-word'}}>
                                                <strong> Attended High School:</strong>
                                                <span> {profile?.attendedHighSchool} </span>
                                            </Col>
                                    }


                                    <Container className="mt-5 bg-body-tertiary d-inline-block">
                                        <h5 className="text-start w-100 text-muted">College 1</h5>
                                    </Container>
                                    {
                                        profile?.attendedCollege1 === "Yes" ?
                                            <>
                                                <Row className="pt-1 mx-auto">
                                                    <Col md={3} className="d-flex flex-column"
                                                         style={{wordWrap: 'break-word'}}>
                                                        <strong> Attended College:</strong>
                                                        <span>  {profile?.attendedCollege1} </span>
                                                    </Col>
                                                    <Col md={3} className="d-flex flex-column">
                                                        <strong> College Start:</strong>
                                                        <span>  {profile?.collegeStart1}</span>
                                                    </Col>
                                                    <Col md={3} className="d-flex flex-column">
                                                        <strong> College End: </strong>
                                                        <span> {profile?.collegeEnd1}</span>
                                                    </Col>
                                                    <Col md={3} className="d-flex flex-column">
                                                        <strong> Degree: </strong>
                                                        <span> {profile?.degree1}</span>
                                                    </Col>
                                                </Row>
                                                <Row className="pt-3 mx-auto">
                                                    <Col md={3} className="d-flex flex-column"
                                                         style={{wordWrap: 'break-word'}}>
                                                        <strong> College Name: </strong>
                                                        <span>   {profile?.collegeName1} </span>
                                                    </Col>
                                                    <Col md={3} className="d-flex flex-column">
                                                        <strong> College Address:</strong>
                                                        <span>  {profile?.collegeAddress1}</span>
                                                    </Col>
                                                </Row>

                                                <Row className="pt-3 mx-auto">
                                                    <Col md={3} className="d-flex flex-column"
                                                         style={{wordWrap: 'break-word'}}>
                                                        <strong> Major: </strong>
                                                        <span>  {profile?.major1} </span>
                                                    </Col>
                                                    <Col md={3} className="d-flex flex-column">
                                                        <strong> Minor: </strong>
                                                        <span>  {profile?.minor1}</span>
                                                    </Col>
                                                    <Col md={3} className="d-flex flex-column">
                                                        <strong> College Credit Hours:</strong>
                                                        <span>  {profile?.collegeCreditHours1}</span>
                                                    </Col>
                                                </Row>

                                                <Row className="pt-3 mx-auto">
                                                    <Col md={6} className="d-flex flex-column"
                                                         style={{wordWrap: 'break-word'}}>
                                                        <strong> College Form Upload:</strong>
                                                        <span>
  {profile?.College1_Form_OriginalName ? profile?.College1_Form_OriginalName + ',' : ''}{" "}
                                                            {profile?.College1_Form_UploadDate ? moment(profile?.College1_Form_UploadDate).format('MMMM Do YYYY, h:mm:ss a, ') : ''}
                                                            {parseInt(profile?.College1_Form_FileSize) ? prettyBytes(parseInt(profile?.College1_Form_FileSize)) : 'No File Uploaded'}
              </span>
                                                    </Col>
                                                </Row>
                                            </>

                                            :

                                            <Col md={3} className="d-flex flex-column"
                                                 style={{wordWrap: 'break-word'}}>
                                                <strong> Attended College:</strong>
                                                <span>  {profile?.attendedCollege1} </span>
                                            </Col>
                                    }

                                    <Container className="mt-5 bg-body-tertiary d-inline-block">
                                        <h5 className="text-start w-100 text-muted">College 2</h5>
                                    </Container>
                                    {
                                        profile?.attendedCollege2 === "Yes" ?
                                            <>
                                                <Row className="pt-1 mx-auto">
                                                    <Col md={3} className="d-flex flex-column"
                                                         style={{wordWrap: 'break-word'}}>
                                                        <strong> Attended College 2:</strong>
                                                        <span>  {profile?.attendedCollege2} </span>
                                                    </Col>
                                                    <Col md={3} className="d-flex flex-column">
                                                        <strong> College Start 2:</strong>
                                                        <span>  {profile?.collegeStart2}</span>
                                                    </Col>
                                                    <Col md={3} className="d-flex flex-column">
                                                        <strong> College End 2: </strong>
                                                        <span> {profile?.collegeEnd2}</span>
                                                    </Col>
                                                    <Col md={3} className="d-flex flex-column">
                                                        <strong> Degree 2: </strong>
                                                        <span> {profile?.degree2}</span>
                                                    </Col>
                                                </Row>
                                                <Row className="pt-3 mx-auto">
                                                    <Col md={3} className="d-flex flex-column"
                                                         style={{wordWrap: 'break-word'}}>
                                                        <strong> College Name 2: </strong>
                                                        <span>   {profile?.collegeName2} </span>
                                                    </Col>
                                                    <Col md={3} className="d-flex flex-column">
                                                        <strong> College Address 2:</strong>
                                                        <span>  {profile?.collegeAddress2}</span>
                                                    </Col>
                                                </Row>

                                                <Row className="pt-3 mx-auto">
                                                    <Col md={3} className="d-flex flex-column"
                                                         style={{wordWrap: 'break-word'}}>
                                                        <strong> Major 2: </strong>
                                                        <span>  {profile?.major2} </span>
                                                    </Col>
                                                    <Col md={3} className="d-flex flex-column">
                                                        <strong> Minor 2: </strong>
                                                        <span>  {profile?.minor2}</span>
                                                    </Col>
                                                    <Col md={3} className="d-flex flex-column">
                                                        <strong> College Credit Hours 2:</strong>
                                                        <span>  {profile?.collegeCreditHours2}</span>
                                                    </Col>
                                                </Row>

                                                <Row className="pt-3 mx-auto">
                                                    <Col md={6} className="d-flex flex-column"
                                                         style={{wordWrap: 'break-word'}}>
                                                        <strong> College 2 Form Upload:</strong>
                                                        <span>
    {profile?.College2_Form_OriginalName ? profile?.College2_Form_OriginalName + ',' : ''}{" "}
                                                            {profile?.College2_Form_UploadDate ? moment(profile?.College2_Form_UploadDate).format('MMMM Do YYYY, h:mm:ss a, ') : ''}
                                                            {parseInt(profile?.College2_Form_FileSize) ? prettyBytes(parseInt(profile?.College2_Form_FileSize)) : 'No File Uploaded'}
            </span>
                                                    </Col>
                                                </Row>
                                            </>

                                            :
                                            <Row className="pt-1 mx-auto">
                                                <Col md={3} className="d-flex flex-column"
                                                     style={{wordWrap: 'break-word'}}>
                                                    <strong> Additional College:</strong>
                                                    <span>  {profile?.attendedCollege2} </span>
                                                </Col>
                                            </Row>
                                    }

                                    <Container className="mt-5 bg-body-tertiary d-inline-block">
                                        <h5 className="text-start w-100 text-muted">Tech School</h5>
                                    </Container>

                                    {
                                        profile?.attendedTechSchool === "Yes" ?
                                            <>
                                                <Row className="pt-1 mx-auto">
                                                    <Col md={3} className="d-flex flex-column"
                                                         style={{wordWrap: 'break-word'}}>
                                                        <strong> Attended Technical School:</strong>
                                                        <span> {profile?.attendedTechSchool} </span>
                                                    </Col>
                                                    <Col md={3} className="d-flex flex-column">
                                                        <strong> Tech School Start:</strong>
                                                        <span> {profile?.techStart1} </span>
                                                    </Col>
                                                    <Col md={3} className="d-flex flex-column">
                                                        <strong> Tech School End: </strong>
                                                        <span> {profile?.techEnd1}</span>
                                                    </Col>
                                                    <Col md={3} className="d-flex flex-column">
                                                        <strong> Tech School Degree: </strong>
                                                        <span> {profile?.techDegree1}</span>
                                                    </Col>
                                                </Row>
                                                <Row className="pt-3 mx-auto">
                                                    <Col md={3} className="d-flex flex-column"
                                                         style={{wordWrap: 'break-word'}}>
                                                        <strong> Tech School Name: </strong>
                                                        <span> {profile?.techSchoolName1} </span>
                                                    </Col>
                                                    <Col md={3} className="d-flex flex-column">
                                                        <strong> Tech School Address: </strong>
                                                        <span> {profile?.techSchoolAddress1} </span>
                                                    </Col>
                                                </Row>
                                                <Row className="pt-3 mx-auto">
                                                    <Col md={3} className="d-flex flex-column"
                                                         style={{wordWrap: 'break-word'}}>
                                                        <strong> Tech School Major: </strong>
                                                        <span> {profile?.techMajor1} </span>
                                                    </Col>
                                                    <Col md={3} className="d-flex flex-column">
                                                        <strong> Tech School Minor: </strong>
                                                        <span> {profile?.techMinor1}</span>
                                                    </Col>
                                                    <Col md={3} className="d-flex flex-column">
                                                        <strong> Tech School Credit Hours:</strong>
                                                        <span> {profile?.techCreditHours1}</span>
                                                    </Col>
                                                </Row>
                                                <Row className="pt-3 mx-auto">
                                                    <Col md={6} className="d-flex flex-column"
                                                         style={{wordWrap: 'break-word'}}>
                                                        <strong> Tech School Form Upload:</strong>
                                                        <span>
                      {profile?.TechSchool1_Form_OriginalName ? profile?.TechSchool1_Form_OriginalName + ',' : ''}{" "}
                                                            {profile?.TechSchool1_Form_UploadDate ? moment(profile?.TechSchool1_Form_UploadDate).format('MMMM Do YYYY, h:mm:ss a, ') : ''}
                                                            {parseInt(profile?.TechSchool1_Form_FileSize) ? prettyBytes(parseInt(profile?.TechSchool1_Form_FileSize)) : 'No File Uploaded'}
                    </span>
                                                    </Col>
                                                </Row>
                                            </>

                                            :

                                            <Col md={3} className="d-flex flex-column" style={{wordWrap: 'break-word'}}>
                                                <strong> Attended Technical School:</strong>
                                                <span> {profile?.attendedTechSchool} </span>
                                            </Col>
                                    }
                                    <Container className="d-flex align-items-center py-1 bg-header mt-3">
                                        <h3 className="text-center w-100">Certifications/Licenses, Training, Job Related
                                            Skills</h3>

                                    </Container>
                                    <Row className="pt-3 mx-auto">
                                        <Col md={3} className="d-flex flex-column" style={{wordWrap: 'break-word'}}>
                                            <strong>Skills 1:</strong>
                                            <span> {application?.Skills1} </span>
                                        </Col>
                                        <Col md={3} className="d-flex flex-column">
                                            <strong>Skills 2:</strong>
                                            <span>{application?.Skills2}</span>
                                        </Col>
                                        <Col md={3} className="d-flex flex-column">
                                            <strong>Skills 3:</strong>
                                            <span> {application?.Skills3}</span>
                                        </Col>
                                        <Col md={3} className="d-flex flex-column">
                                            <strong>Skills 4:</strong>
                                            <span> {application?.Skills4}</span>
                                        </Col>

                                    </Row>
                                    <Container className="mt-3 bg-body-tertiary d-inline-block">
                                        <h5 className="text-start w-100 text-muted">Training 1</h5>
                                    </Container>
                                    <Row className="pt-1 mx-auto">
                                        <Col md={3} className="d-flex flex-column" style={{wordWrap: 'break-word'}}>
                                            <strong>Training Name:</strong>
                                            <span>{application.Trainings1_Name}</span>
                                        </Col>
                                        <Col md={3} className="d-flex flex-column">
                                            <strong>From:</strong>
                                            <span>{application?.Trainings1_From}</span>
                                        </Col>
                                        <Col md={3} className="d-flex flex-column">
                                            <strong>To:</strong>
                                            <span>{application?.Trainings1_To}</span>
                                        </Col>
                                        <Col md={3} className="d-flex flex-column">
                                            <strong>Exp. Date:</strong>
                                            <span>{application?.Trainings1_ExpirationDate}</span>
                                        </Col>

                                    </Row>

                                    <Container className="mt-3 bg-body-tertiary d-inline-block">
                                        <h5 className="text-start w-100 text-muted">Training 2</h5>
                                    </Container>
                                    <Row className="pt-1 mx-auto">
                                        <Col md={3} className="d-flex flex-column" style={{wordWrap: 'break-word'}}>
                                            <strong>Training Name:</strong>
                                            <span>{application.Trainings2_Name}</span>
                                        </Col>
                                        <Col md={3} className="d-flex flex-column">
                                            <strong>From:</strong>
                                            <span>{application?.Trainings2_From}</span>
                                        </Col>
                                        <Col md={3} className="d-flex flex-column">
                                            <strong>To:</strong>
                                            <span>{application?.Trainings2_To}</span>
                                        </Col>
                                        <Col md={3} className="d-flex flex-column">
                                            <strong>Exp. Date:</strong>
                                            <span>{application?.Trainings2_ExpirationDate}</span>
                                        </Col>

                                    </Row>

                                    <Container className="mt-3 bg-body-tertiary d-inline-block">
                                        <h5 className="text-start w-100 text-muted">Training 3</h5>
                                    </Container>
                                    <Row className="pt-1 mx-auto">
                                        <Col md={3} className="d-flex flex-column" style={{wordWrap: 'break-word'}}>
                                            <strong>Training Name:</strong>
                                            <span>{application.Trainings3_Name}</span>
                                        </Col>
                                        <Col md={3} className="d-flex flex-column">
                                            <strong>From:</strong>
                                            <span>{application?.Trainings3_From}</span>
                                        </Col>
                                        <Col md={3} className="d-flex flex-column">
                                            <strong>To:</strong>
                                            <span>{application?.Trainings3_To}</span>
                                        </Col>
                                        <Col md={3} className="d-flex flex-column">
                                            <strong>Exp. Date:</strong>
                                            <span>{application?.Trainings3_ExpirationDate}</span>
                                        </Col>

                                    </Row>
                                    <Container className="mt-3 bg-body-tertiary d-inline-block">
                                        <h5 className="text-start w-100 text-muted">Training 4</h5>
                                    </Container>
                                    <Row className="pt-1 mx-auto">
                                        <Col md={3} className="d-flex flex-column" style={{wordWrap: 'break-word'}}>
                                            <strong>Training Name:</strong>
                                            <span>{application.Trainings4_Name}</span>
                                        </Col>
                                        <Col md={3} className="d-flex flex-column">
                                            <strong>From:</strong>
                                            <span>{application?.Trainings4_From}</span>
                                        </Col>
                                        <Col md={3} className="d-flex flex-column">
                                            <strong>To:</strong>
                                            <span>{application?.Trainings4_To}</span>
                                        </Col>
                                        <Col md={3} className="d-flex flex-column">
                                            <strong>Exp. Date:</strong>
                                            <span>{application?.Trainings4_ExpirationDate}</span>
                                        </Col>

                                    </Row>
                                    <Container className="mt-3 bg-body-tertiary d-inline-block">
                                        <h5 className="text-start w-100 text-muted">Training 5</h5>
                                    </Container>
                                    <Row className="pt-1 mx-auto">
                                        <Col md={3} className="d-flex flex-column" style={{wordWrap: 'break-word'}}>
                                            <strong>Training Name:</strong>
                                            <span>{application.Trainings5_Name}</span>
                                        </Col>
                                        <Col md={3} className="d-flex flex-column">
                                            <strong>From:</strong>
                                            <span>{application?.Trainings5_From}</span>
                                        </Col>
                                        <Col md={3} className="d-flex flex-column">
                                            <strong>To:</strong>
                                            <span>{application?.Trainings5_To}</span>
                                        </Col>
                                        <Col md={3} className="d-flex flex-column">
                                            <strong>Exp. Date:</strong>
                                            <span>{application?.Trainings5_ExpirationDate}</span>
                                        </Col>

                                    </Row>
                                    <Container className="mt-3 bg-body-tertiary d-inline-block">
                                        <h5 className="text-start w-100 text-muted">Training 6</h5>
                                    </Container>
                                    <Row className="pt-1 mx-auto">
                                        <Col md={3} className="d-flex flex-column" style={{wordWrap: 'break-word'}}>
                                            <strong>Training Name:</strong>
                                            <span>{application.Trainings6_Name}</span>
                                        </Col>
                                        <Col md={3} className="d-flex flex-column">
                                            <strong>From:</strong>
                                            <span>{application?.Trainings6_From}</span>
                                        </Col>
                                        <Col md={3} className="d-flex flex-column">
                                            <strong>To:</strong>
                                            <span>{application?.Trainings6_To}</span>
                                        </Col>
                                        <Col md={3} className="d-flex flex-column">
                                            <strong>Exp. Date:</strong>
                                            <span>{application?.Trainings6_ExpirationDate}</span>
                                        </Col>
                                    </Row>
                                    <Container className="d-flex align-items-center py-1 bg-header mt-3">
                                        <h3 className="text-center w-100">Work Experience</h3>
                                    </Container>
                                    <Container className="mt-0 bg-body-tertiary d-inline-block">
                                        <h5 className="text-start w-100 text-muted">Employment 1</h5>
                                    </Container>
                                    <Row className="pt-3 mx-auto">
                                        <Col md={3} className="d-flex flex-column" style={{wordWrap: 'break-word'}}>
                                            <strong>Employer:</strong>
                                            <span> {profile?.employer1} </span>
                                        </Col>
                                        <Col md={3} className="d-flex flex-column">
                                            <strong> Employer Phone:</strong>
                                            <span> {profile?.employerPhone1}</span>
                                        </Col>
                                        <Col md={3} className="d-flex flex-column">
                                            <strong> Employer Start:</strong>
                                            <span>  {profile?.employerStart1}</span>
                                        </Col>
                                        <Col md={3} className="d-flex flex-column">
                                            <strong> Employer End:</strong>
                                            <span>  {profile?.employerEnd1}</span>
                                        </Col>

                                    </Row>
                                    <Row className="pt-3 mx-auto">
                                        <Col md={3} className="d-flex flex-column" style={{wordWrap: 'break-word'}}>
                                            <strong> Employer Address:</strong>
                                            <span>  {profile?.employerAddress1} </span>
                                        </Col>
                                        <Col md={3} className="d-flex flex-column">
                                            <strong> Employer Supervisor:</strong>
                                            <span>  {profile?.employerSupervisor1}</span>
                                        </Col>
                                        <Col md={3} className="d-flex flex-column">
                                            <strong> Employer Job Title:</strong>
                                            <span>    {profile?.employerJobTitle1}</span>
                                        </Col>

                                    </Row>
                                    <Row className="pt-3 mx-auto">
                                        <Col md={6} className="d-flex flex-column" style={{wordWrap: 'break-word'}}>
                                            <strong> Employer Reason:</strong>
                                            <span>   {profile?.employerReason1} </span>
                                        </Col>
                                        <Col md={6} className="d-flex flex-column">
                                            <strong> Employer Duties:</strong>
                                            <span>   {profile?.employerDuties1}</span>
                                        </Col>

                                    </Row>
                                    <Container className="mt-5 bg-body-tertiary d-inline-block">
                                        <h5 className="text-start w-100 text-muted">Employment 2</h5>
                                    </Container>
                                    <Row className="pt-3 mx-auto">
                                        <Col md={3} className="d-flex flex-column" style={{wordWrap: 'break-word'}}>
                                            <strong>Employer:</strong>
                                            <span> {profile?.employer2} </span>
                                        </Col>
                                        <Col md={3} className="d-flex flex-column">
                                            <strong> Employer Phone:</strong>
                                            <span> {profile?.employerPhone2}</span>
                                        </Col>
                                        <Col md={3} className="d-flex flex-column">
                                            <strong> Employer Start:</strong>
                                            <span>  {profile?.employerStart2}</span>
                                        </Col>
                                        <Col md={3} className="d-flex flex-column">
                                            <strong> Employer End:</strong>
                                            <span>  {profile?.employerEnd2}</span>
                                        </Col>

                                    </Row>
                                    <Row className="pt-3 mx-auto">
                                        <Col md={3} className="d-flex flex-column" style={{wordWrap: 'break-word'}}>
                                            <strong> Employer Address:</strong>
                                            <span>  {profile?.employerAddress2} </span>
                                        </Col>
                                        <Col md={3} className="d-flex flex-column">
                                            <strong> Employer Supervisor:</strong>
                                            <span>  {profile?.employerSupervisor2}</span>
                                        </Col>
                                        <Col md={3} className="d-flex flex-column">
                                            <strong> Employer Job Title:</strong>
                                            <span>    {profile?.employerJobTitle2}</span>
                                        </Col>

                                    </Row>
                                    <Row className="pt-3 mx-auto">
                                        <Col md={6} className="d-flex flex-column" style={{wordWrap: 'break-word'}}>
                                            <strong> Employer Reason:</strong>
                                            <span>   {profile?.employerReason2} </span>
                                        </Col>
                                        <Col md={6} className="d-flex flex-column">
                                            <strong> Employer Duties:</strong>
                                            <span>   {profile?.employerDuties2}</span>
                                        </Col>

                                    </Row>

                                    <Container className="mt-5 bg-body-tertiary d-inline-block">
                                        <h5 className="text-start w-100 text-muted">Employment 3</h5>
                                    </Container>
                                    <Row className="pt-3 mx-auto">
                                        <Col md={3} className="d-flex flex-column" style={{wordWrap: 'break-word'}}>
                                            <strong>Employer:</strong>
                                            <span> {profile?.employer3} </span>
                                        </Col>
                                        <Col md={3} className="d-flex flex-column">
                                            <strong> Employer Phone:</strong>
                                            <span> {profile?.employerPhone3}</span>
                                        </Col>
                                        <Col md={3} className="d-flex flex-column">
                                            <strong> Employer Start:</strong>
                                            <span>  {profile?.employerStart3}</span>
                                        </Col>
                                        <Col md={3} className="d-flex flex-column">
                                            <strong> Employer End:</strong>
                                            <span>  {profile?.employerEnd3}</span>
                                        </Col>

                                    </Row>
                                    <Row className="pt-3 mx-auto">
                                        <Col md={3} className="d-flex flex-column" style={{wordWrap: 'break-word'}}>
                                            <strong> Employer Address:</strong>
                                            <span>  {profile?.employerAddress3} </span>
                                        </Col>
                                        <Col md={3} className="d-flex flex-column">
                                            <strong> Employer Supervisor:</strong>
                                            <span>  {profile?.employerSupervisor3}</span>
                                        </Col>
                                        <Col md={3} className="d-flex flex-column">
                                            <strong> Employer Job Title:</strong>
                                            <span>    {profile?.employerJobTitle3}</span>
                                        </Col>

                                    </Row>
                                    <Row className="pt-3 mx-auto">
                                        <Col md={6} className="d-flex flex-column" style={{wordWrap: 'break-word'}}>
                                            <strong> Employer Reason:</strong>
                                            <span>   {profile?.employerReason3} </span>
                                        </Col>
                                        <Col md={6} className="d-flex flex-column">
                                            <strong> Employer Duties:</strong>
                                            <span>   {profile?.employerDuties3}</span>
                                        </Col>

                                    </Row>
                                    <Container className="mt-5 bg-body-tertiary d-inline-block">
                                        <h5 className="text-start w-100 text-muted">Employment 4</h5>
                                    </Container>
                                    <Row className="pt-3 mx-auto">
                                        <Col md={3} className="d-flex flex-column" style={{wordWrap: 'break-word'}}>
                                            <strong>Employer:</strong>
                                            <span> {profile?.employer4} </span>
                                        </Col>
                                        <Col md={3} className="d-flex flex-column">
                                            <strong> Employer Phone:</strong>
                                            <span> {profile?.employerPhone4}</span>
                                        </Col>
                                        <Col md={3} className="d-flex flex-column">
                                            <strong> Employer Start:</strong>
                                            <span>  {profile?.employerStart4}</span>
                                        </Col>
                                        <Col md={3} className="d-flex flex-column">
                                            <strong> Employer End:</strong>
                                            <span>  {profile?.employerEnd4}</span>
                                        </Col>

                                    </Row>
                                    <Row className="pt-3 mx-auto">
                                        <Col md={3} className="d-flex flex-column" style={{wordWrap: 'break-word'}}>
                                            <strong> Employer Address:</strong>
                                            <span>  {profile?.employerAddress4} </span>
                                        </Col>
                                        <Col md={3} className="d-flex flex-column">
                                            <strong> Employer Supervisor:</strong>
                                            <span>  {profile?.employerSupervisor4}</span>
                                        </Col>
                                        <Col md={3} className="d-flex flex-column">
                                            <strong> Employer Job Title:</strong>
                                            <span>    {profile?.employerJobTitle4}</span>
                                        </Col>

                                    </Row>
                                    <Row className="pt-3 mx-auto">
                                        <Col md={6} className="d-flex flex-column" style={{wordWrap: 'break-word'}}>
                                            <strong> Employer Reason:</strong>
                                            <span>   {profile?.employerReason4} </span>
                                        </Col>
                                        <Col md={6} className="d-flex flex-column">
                                            <strong> Employer Duties:</strong>
                                            <span>   {profile?.employerDuties4}</span>
                                        </Col>

                                    </Row>
                                    <Container className="mt-5 bg-body-tertiary d-inline-block">
                                        <h5 className="text-start w-100 text-muted">Employment 5</h5>
                                    </Container>
                                    <Row className="pt-3 mx-auto">
                                        <Col md={3} className="d-flex flex-column" style={{wordWrap: 'break-word'}}>
                                            <strong>Employer:</strong>
                                            <span> {profile?.employer5} </span>
                                        </Col>
                                        <Col md={3} className="d-flex flex-column">
                                            <strong> Employer Phone:</strong>
                                            <span> {profile?.employerPhone5}</span>
                                        </Col>
                                        <Col md={3} className="d-flex flex-column">
                                            <strong> Employer Start:</strong>
                                            <span>  {profile?.employerStart5}</span>
                                        </Col>
                                        <Col md={3} className="d-flex flex-column">
                                            <strong> Employer End:</strong>
                                            <span>  {profile?.employerEnd5}</span>
                                        </Col>

                                    </Row>
                                    <Row className="pt-3 mx-auto">
                                        <Col md={3} className="d-flex flex-column" style={{wordWrap: 'break-word'}}>
                                            <strong> Employer Address:</strong>
                                            <span>  {profile?.employerAddress5} </span>
                                        </Col>
                                        <Col md={3} className="d-flex flex-column">
                                            <strong> Employer Supervisor:</strong>
                                            <span>  {profile?.employerSupervisor5}</span>
                                        </Col>
                                        <Col md={3} className="d-flex flex-column">
                                            <strong> Employer Job Title:</strong>
                                            <span>    {profile?.employerJobTitle5}</span>
                                        </Col>

                                    </Row>
                                    <Row className="pt-3 mx-auto">
                                        <Col md={6} className="d-flex flex-column" style={{wordWrap: 'break-word'}}>
                                            <strong> Employer Reason:</strong>
                                            <span>   {profile?.employerReason5} </span>
                                        </Col>
                                        <Col md={6} className="d-flex flex-column">
                                            <strong> Employer Duties:</strong>
                                            <span>   {profile?.employerDuties5}</span>
                                        </Col>

                                    </Row>

                                    <Container className="mt-5 bg-body-tertiary d-inline-block">
                                        <h5 className="text-start w-100 text-muted">Employment 6</h5>
                                    </Container>
                                    <Row className="pt-3 mx-auto">
                                        <Col md={3} className="d-flex flex-column" style={{wordWrap: 'break-word'}}>
                                            <strong>Employer</strong>
                                            <span> {profile?.employer6} </span>
                                        </Col>
                                        <Col md={3} className="d-flex flex-column">
                                            <strong> Employer Phone:</strong>
                                            <span> {profile?.employerPhone6}</span>
                                        </Col>
                                        <Col md={3} className="d-flex flex-column">
                                            <strong> Employer Start:</strong>
                                            <span>  {profile?.employerStart6}</span>
                                        </Col>
                                        <Col md={3} className="d-flex flex-column">
                                            <strong> Employer End:</strong>
                                            <span>  {profile?.employerEnd6}</span>
                                        </Col>

                                    </Row>
                                    <Row className="pt-3 mx-auto">
                                        <Col md={3} className="d-flex flex-column" style={{wordWrap: 'break-word'}}>
                                            <strong> Employer Address:</strong>
                                            <span>  {profile?.employerAddress6} </span>
                                        </Col>
                                        <Col md={3} className="d-flex flex-column">
                                            <strong> Employer Supervisor:</strong>
                                            <span>  {profile?.employerSupervisor6}</span>
                                        </Col>
                                        <Col md={3} className="d-flex flex-column">
                                            <strong> Employer Job Title:</strong>
                                            <span>    {profile?.employerJobTitle6}</span>
                                        </Col>

                                    </Row>
                                    <Row className="pt-3 mx-auto">
                                        <Col md={6} className="d-flex flex-column" style={{wordWrap: 'break-word'}}>
                                            <strong> Employer Reason:</strong>
                                            <span>   {profile?.employerReason6} </span>
                                        </Col>
                                        <Col md={6} className="d-flex flex-column">
                                            <strong> Employer Duties:</strong>
                                            <span>   {profile?.employerDuties6}</span>
                                        </Col>

                                    </Row>
                                    <Container className="mt-0 bg-body-tertiary d-inline-block">
                                        <h5 className="text-start w-100 text-muted">Employment 7</h5>
                                    </Container>
                                    <Row className="pt-3 mx-auto">
                                        <Col md={3} className="d-flex flex-column" style={{wordWrap: 'break-word'}}>
                                            <strong>Employer:</strong>
                                            <span> {profile?.employer7} </span>
                                        </Col>
                                        <Col md={3} className="d-flex flex-column">
                                            <strong> Employer Phone:</strong>
                                            <span> {profile?.employerPhone7}</span>
                                        </Col>
                                        <Col md={3} className="d-flex flex-column">
                                            <strong> Employer Start:</strong>
                                            <span>  {profile?.employerStart7}</span>
                                        </Col>
                                        <Col md={3} className="d-flex flex-column">
                                            <strong> Employer End:</strong>
                                            <span>  {profile?.employerEnd7}</span>
                                        </Col>

                                    </Row>
                                    <Row className="pt-3 mx-auto">
                                        <Col md={3} className="d-flex flex-column" style={{wordWrap: 'break-word'}}>
                                            <strong> Employer Address:</strong>
                                            <span>  {profile?.employerAddress7} </span>
                                        </Col>
                                        <Col md={3} className="d-flex flex-column">
                                            <strong> Employer Supervisor:</strong>
                                            <span>  {profile?.employerSupervisor7}</span>
                                        </Col>
                                        <Col md={3} className="d-flex flex-column">
                                            <strong> Employer Job Title:</strong>
                                            <span>    {profile?.employerJobTitle7}</span>
                                        </Col>

                                    </Row>
                                    <Row className="pt-3 mx-auto">
                                        <Col md={6} className="d-flex flex-column" style={{wordWrap: 'break-word'}}>
                                            <strong> Employer Reason:</strong>
                                            <span>   {profile?.employerReason7} </span>
                                        </Col>
                                        <Col md={6} className="d-flex flex-column">
                                            <strong> Employer Duties:</strong>
                                            <span>   {profile?.employerDuties7}</span>
                                        </Col>

                                    </Row>
                                    <Container className="mt-0 bg-body-tertiary d-inline-block">
                                        <h5 className="text-start w-100 text-muted">Employment 8</h5>
                                    </Container>
                                    <Row className="pt-3 mx-auto">
                                        <Col md={3} className="d-flex flex-column" style={{wordWrap: 'break-word'}}>
                                            <strong>Employer:</strong>
                                            <span> {profile?.employer8} </span>
                                        </Col>
                                        <Col md={3} className="d-flex flex-column">
                                            <strong> Employer Phone:</strong>
                                            <span> {profile?.employerPhone8}</span>
                                        </Col>
                                        <Col md={3} className="d-flex flex-column">
                                            <strong> Employer Start:</strong>
                                            <span>  {profile?.employerStart8}</span>
                                        </Col>
                                        <Col md={3} className="d-flex flex-column">
                                            <strong> Employer End:</strong>
                                            <span>  {profile?.employerEnd8}</span>
                                        </Col>

                                    </Row>
                                    <Row className="pt-3 mx-auto">
                                        <Col md={3} className="d-flex flex-column" style={{wordWrap: 'break-word'}}>
                                            <strong> Employer Address:</strong>
                                            <span>  {profile?.employerAddress8} </span>
                                        </Col>
                                        <Col md={3} className="d-flex flex-column">
                                            <strong> Employer Supervisor:</strong>
                                            <span>  {profile?.employerSupervisor8}</span>
                                        </Col>
                                        <Col md={3} className="d-flex flex-column">
                                            <strong> Employer Job Title:</strong>
                                            <span>    {profile?.employerJobTitle8}</span>
                                        </Col>

                                    </Row>
                                    <Row className="pt-3 mx-auto">
                                        <Col md={6} className="d-flex flex-column" style={{wordWrap: 'break-word'}}>
                                            <strong> Employer Reason:</strong>
                                            <span>   {profile?.employerReason8} </span>
                                        </Col>
                                        <Col md={6} className="d-flex flex-column">
                                            <strong> Employer Duties:</strong>
                                            <span>   {profile?.employerDuties8}</span>
                                        </Col>

                                    </Row>
                                    <Container className="mt-0 bg-body-tertiary d-inline-block">
                                        <h5 className="text-start w-100 text-muted">Employment 9</h5>
                                    </Container>
                                    <Row className="pt-3 mx-auto">
                                        <Col md={3} className="d-flex flex-column" style={{wordWrap: 'break-word'}}>
                                            <strong>Employer:</strong>
                                            <span> {profile?.employer9} </span>
                                        </Col>
                                        <Col md={3} className="d-flex flex-column">
                                            <strong> Employer Phone:</strong>
                                            <span> {profile?.employerPhone9}</span>
                                        </Col>
                                        <Col md={3} className="d-flex flex-column">
                                            <strong> Employer Start:</strong>
                                            <span>  {profile?.employerStart9}</span>
                                        </Col>
                                        <Col md={3} className="d-flex flex-column">
                                            <strong> Employer End:</strong>
                                            <span>  {profile?.employerEnd9}</span>
                                        </Col>

                                    </Row>
                                    <Row className="pt-3 mx-auto">
                                        <Col md={3} className="d-flex flex-column" style={{wordWrap: 'break-word'}}>
                                            <strong> Employer Address:</strong>
                                            <span>  {profile?.employerAddress9} </span>
                                        </Col>
                                        <Col md={3} className="d-flex flex-column">
                                            <strong> Employer Supervisor:</strong>
                                            <span>  {profile?.employerSupervisor9}</span>
                                        </Col>
                                        <Col md={3} className="d-flex flex-column">
                                            <strong> Employer Job Title:</strong>
                                            <span>    {profile?.employerJobTitle9}</span>
                                        </Col>

                                    </Row>
                                    <Row className="pt-3 mx-auto">
                                        <Col md={6} className="d-flex flex-column" style={{wordWrap: 'break-word'}}>
                                            <strong> Employer Reason:</strong>
                                            <span>   {profile?.employerReason9} </span>
                                        </Col>
                                        <Col md={6} className="d-flex flex-column">
                                            <strong> Employer Duties:</strong>
                                            <span>   {profile?.employerDuties9}</span>
                                        </Col>

                                    </Row>
                                    <Container className="mt-0 bg-body-tertiary d-inline-block">
                                        <h5 className="text-start w-100 text-muted">Employment 10</h5>
                                    </Container>
                                    <Row className="pt-3 mx-auto">
                                        <Col md={3} className="d-flex flex-column" style={{wordWrap: 'break-word'}}>
                                            <strong>Employer:</strong>
                                            <span> {profile?.employer10} </span>
                                        </Col>
                                        <Col md={3} className="d-flex flex-column">
                                            <strong> Employer Phone:</strong>
                                            <span> {profile?.employerPhone10}</span>
                                        </Col>
                                        <Col md={3} className="d-flex flex-column">
                                            <strong> Employer Start:</strong>
                                            <span>  {profile?.employerStart10}</span>
                                        </Col>
                                        <Col md={3} className="d-flex flex-column">
                                            <strong> Employer End:</strong>
                                            <span>  {profile?.employerEnd10}</span>
                                        </Col>

                                    </Row>
                                    <Row className="pt-3 mx-auto">
                                        <Col md={3} className="d-flex flex-column" style={{wordWrap: 'break-word'}}>
                                            <strong> Employer Address:</strong>
                                            <span>  {profile?.employerAddress10} </span>
                                        </Col>
                                        <Col md={3} className="d-flex flex-column">
                                            <strong> Employer Supervisor:</strong>
                                            <span>  {profile?.employerSupervisor10}</span>
                                        </Col>
                                        <Col md={3} className="d-flex flex-column">
                                            <strong> Employer Job Title:</strong>
                                            <span>    {profile?.employerJobTitle10}</span>
                                        </Col>

                                    </Row>
                                    <Row className="pt-3 mx-auto">
                                        <Col md={6} className="d-flex flex-column" style={{wordWrap: 'break-word'}}>
                                            <strong> Employer Reason:</strong>
                                            <span>   {profile?.employerReason10} </span>
                                        </Col>
                                        <Col md={6} className="d-flex flex-column">
                                            <strong> Employer Duties:</strong>
                                            <span>   {profile?.employerDuties10}</span>
                                        </Col>

                                    </Row>
                                    <Container className="d-flex align-items-center py-1 bg-header mt-3">
                                        <h3 className="text-center w-100">Additional Info</h3>
                                    </Container>
                                    <Container className="mt-0 bg-body-tertiary d-inline-block">
                                        <h5 className="text-start w-100 text-muted">Felony</h5>
                                    </Container>
                                    <Row className="pt-3 mx-auto">
                                        <Col md={3} className="d-flex flex-column" style={{wordWrap: 'break-word'}}>
                                            <strong>Felony:</strong>
                                            <span> {profile?.felony} </span>
                                        </Col>
                                        <Col md={3} className="d-flex flex-column">
                                            <strong>Felony Date:</strong>
                                            <span>{profile?.felonyDate}</span>
                                        </Col>
                                        <Col md={3} className="d-flex flex-column">
                                            <strong>Felony Reason: </strong>
                                            <span> {profile?.felonyReason}</span>
                                        </Col>
                                    </Row>
                                    <Container className="mt-5 bg-body-tertiary d-inline-block">
                                        <h5 className="text-start w-100 text-muted">Misdemeanor</h5>
                                    </Container>
                                    <Row className="pt-3 mx-auto">
                                        <Col md={3} className="d-flex flex-column" style={{wordWrap: 'break-word'}}>
                                            <strong>Misdemeanor:</strong>
                                            <span> {profile?.misdemeanor} </span>
                                        </Col>
                                        <Col md={3} className="d-flex flex-column">
                                            <strong> Misdemeanor Date:</strong>
                                            <span> {profile?.misdemeanorDate}</span>
                                        </Col>
                                        <Col md={3} className="d-flex flex-column">
                                            <strong> Misdemeanor Reason: </strong>
                                            <span>  {profile?.misdemeanorReason}</span>
                                        </Col>
                                    </Row>
                                    <Container className="mt-5 bg-body-tertiary d-inline-block">
                                        <h5 className="text-start w-100 text-muted">Physical</h5>
                                    </Container>
                                    <Row className="pt-3 mx-auto">
                                        <Col md={3} className="d-flex flex-column" style={{wordWrap: 'break-word'}}>
                                            <strong>Physical:</strong>
                                            <span> {profile?.physical} </span>
                                        </Col>
                                    </Row>
                                    <Row className="pt-3 mx-auto">
                                        <Col md={3} className="d-flex flex-column" style={{wordWrap: 'break-word'}}>
                                            <strong> Physical Name 1:</strong>
                                            <span>   {profile?.physicalName1} </span>
                                        </Col>
                                        <Col md={9} className="d-flex flex-column">
                                            <strong> Physical Reason 1:</strong>
                                            <span> {profile?.physicalReason1}</span>
                                        </Col>
                                    </Row>
                                    <Row className="pt-3 mx-auto">
                                        <Col md={3} className="d-flex flex-column" style={{wordWrap: 'break-word'}}>
                                            <strong> Physical Name 2:</strong>
                                            <span>   {profile?.physicalName2} </span>
                                        </Col>
                                        <Col md={9} className="d-flex flex-column">
                                            <strong> Physical Reason 2:</strong>
                                            <span> {profile?.physicalReason2}</span>
                                        </Col>
                                    </Row>
                                    <Row className="pt-3 mx-auto">
                                        <Col md={3} className="d-flex flex-column" style={{wordWrap: 'break-word'}}>
                                            <strong> Physical Name 3:</strong>
                                            <span>   {profile?.physicalName3} </span>
                                        </Col>
                                        <Col md={9} className="d-flex flex-column">
                                            <strong> Physical Reason 3:</strong>
                                            <span> {profile?.physicalReason3}</span>
                                        </Col>
                                    </Row>
                                    <Container className="mt-5 bg-body-tertiary d-inline-block">
                                        <h5 className="text-start w-100 text-muted">Relations</h5>
                                    </Container>
                                    <Row className="pt-3 mx-auto">
                                        <Col md={3} className="d-flex flex-column" style={{wordWrap: 'break-word'}}>
                                            <strong>Relations:</strong>
                                            <span> {profile?.relations}</span>
                                        </Col>
                                    </Row>
                                    <Row className="pt-3 mx-auto">
                                        <Col md={3} className="d-flex flex-column" style={{wordWrap: 'break-word'}}>
                                            <strong> Relations Name 1:</strong>
                                            <span>   {profile?.relationsName1} </span>
                                        </Col>
                                        <Col md={3} className="d-flex flex-column">
                                            <strong> Relations Department 1:</strong>
                                            <span>  {profile?.relationsDepartment1}</span>
                                        </Col>
                                        <Col md={3} className="d-flex flex-column" style={{wordWrap: 'break-word'}}>
                                            <strong> Relations Relationship 1:</strong>
                                            <span>    {profile?.relationsRelationship1} </span>
                                        </Col>
                                    </Row>
                                    <Row className="pt-3 mx-auto">
                                        <Col md={3} className="d-flex flex-column" style={{wordWrap: 'break-word'}}>
                                            <strong> Relations Name 2:</strong>
                                            <span>   {profile?.relationsName2} </span>
                                        </Col>
                                        <Col md={3} className="d-flex flex-column">
                                            <strong> Relations Department 2:</strong>
                                            <span>  {profile?.relationsDepartment2}</span>
                                        </Col>
                                        <Col md={3} className="d-flex flex-column" style={{wordWrap: 'break-word'}}>
                                            <strong> Relations Relationship 2:</strong>
                                            <span>    {profile?.relationsRelationship2} </span>
                                        </Col>
                                    </Row>

                                    <Container className="mt-5 bg-body-tertiary d-inline-block">
                                        <h5 className="text-start w-100 text-muted">Optional Additional Uploads</h5>
                                    </Container>
                                    <Row className="pt-3 mx-auto">
                                        <Col md={6} className="d-flex flex-column" style={{wordWrap: 'break-word'}}>
                                            <strong> Additional Info Field 1 Upload:</strong>
                                            <span>
        {profile?.Additional_Info_Field_1_OriginalName ? profile?.Additional_Info_Field_1_OriginalName + ',' : ''}{" "}
                                                {profile?.Additional_Info_Field_1_UploadDate ? moment(profile?.Additional_Info_Field_1_UploadDate).format('MMMM Do YYYY, h:mm:ss a, ') : ''}
                                                {parseInt(profile?.Additional_Info_Field_1_FileSize) ? prettyBytes(parseInt(profile?.Additional_Info_Field_1_FileSize)) : 'No File Uploaded'}
    </span>
                                        </Col>

                                    </Row>
                                    <Row className="pt-3 mx-auto">
                                        <Col md={6} className="d-flex flex-column" style={{wordWrap: 'break-word'}}>
                                            <strong> Additional Info Field 2 Upload:</strong>
                                            <span>
        {profile?.Additional_Info_Field_2_OriginalName ? profile?.Additional_Info_Field_2_OriginalName + ',' : ''}{" "}
                                                {profile?.Additional_Info_Field_2_UploadDate ? moment(profile?.Additional_Info_Field_2_UploadDate).format('MMMM Do YYYY, h:mm:ss a, ') : ''}
                                                {parseInt(profile?.Additional_Info_Field_2_FileSize) ? prettyBytes(parseInt(profile?.Additional_Info_Field_2_FileSize)) : 'No File Uploaded'}
    </span>
                                        </Col>
                                    </Row>

                                    <Row className="pt-3 mx-auto">
                                        <Col md={6} className="d-flex flex-column" style={{wordWrap: 'break-word'}}>
                                            <strong> Additional Info Field 3 Upload:</strong>
                                            <span>
        {profile?.Additional_Info_Field_3_OriginalName ? profile?.Additional_Info_Field_3_OriginalName + ',' : ''}{" "}
                                                {profile?.Additional_Info_Field_3_UploadDate ? moment(profile?.Additional_Info_Field_3_UploadDate).format('MMMM Do YYYY, h:mm:ss a, ') : ''}
                                                {parseInt(profile?.Additional_Info_Field_3_FileSize) ? prettyBytes(parseInt(profile?.Additional_Info_Field_3_FileSize)) : 'No File Uploaded'}
    </span>
                                        </Col>
                                    </Row>
                                    <Row className="pt-3 mx-auto">
                                        <Col md={6} className="d-flex flex-column" style={{wordWrap: 'break-word'}}>
                                            <strong> Additional Info Field 4 Upload:</strong>
                                            <span>
        {profile?.Additional_Info_Field_4_OriginalName ? profile?.Additional_Info_Field_4_OriginalName + ',' : ''}{" "}
                                                {profile?.Additional_Info_Field_4_UploadDate ? moment(profile?.Additional_Info_Field_4_UploadDate).format('MMMM Do YYYY, h:mm:ss a, ') : ''}
                                                {parseInt(profile?.Additional_Info_Field_4_FileSize) ? prettyBytes(parseInt(profile?.Additional_Info_Field_4_FileSize)) : 'No File Uploaded'}
    </span>
                                        </Col>
                                    </Row>
                                    <Row className="pt-3 mx-auto">
                                        <Col md={6} className="d-flex flex-column" style={{wordWrap: 'break-word'}}>
                                            <strong> Additional Info Field 5 Upload:</strong>
                                            <span>
        {profile?.Additional_Info_Field_5_OriginalName ? profile?.Additional_Info_Field_5_OriginalName + ',' : ''}{" "}
                                                {profile?.Additional_Info_Field_5_UploadDate ? moment(profile?.Additional_Info_Field_5_UploadDate).format('MMMM Do YYYY, h:mm:ss a, ') : ''}
                                                {parseInt(profile?.Additional_Info_Field_5_FileSize) ? prettyBytes(parseInt(profile?.Additional_Info_Field_5_FileSize)) : 'No File Uploaded'}
    </span>
                                        </Col>
                                    </Row>
                                    <Row className="pt-3 mx-auto">
                                        <Col md={6} className="d-flex flex-column" style={{wordWrap: 'break-word'}}>
                                            <strong> Additional Info Field 6 Upload:</strong>
                                            <span>
        {profile?.Additional_Info_Field_6_OriginalName ? profile?.Additional_Info_Field_6_OriginalName + ',' : ''}{" "}
                                                {profile?.Additional_Info_Field_6_UploadDate ? moment(profile?.Additional_Info_Field_6_UploadDate).format('MMMM Do YYYY, h:mm:ss a, ') : ''}
                                                {parseInt(profile?.Additional_Info_Field_6_FileSize) ? prettyBytes(parseInt(profile?.Additional_Info_Field_6_FileSize)) : 'No File Uploaded'}
    </span>
                                        </Col>
                                    </Row>

                                    <div
                                        className="d-flex flex-column flex-md-row mt-4 justify-content-center align-items-center">

                                        <button className="btn btn-outline-primary mb-3 me-2 fw-bold"
                                                onClick={() => navigate('/application')}>
                                            <IoIosPaper/> My Applications
                                        </button>
                                        <button className="btn btn-outline-primary mb-3 fw-bold"
                                                onClick={() => navigate('/jobs')}>
                                            <IoIosSearch/> Jobs
                                        </button>
                                    </div>
                                    {/* {<p>First Name: {profile?.firstName} </p>}
                                {<p>Middle Name: {profile?.middleName} </p>}
                                {<p>Last Name: {profile?.lastName} </p>}
                                {<p>Suffix: {profile?.suffix} </p>}
                                {<p>Phone Number: {profile?.phoneNumber} </p>}
                                {<p>dob: {profile?.dob} </p>}
                                {<p>Gender: {profile?.gender} </p>}
                                {
                                    <p>
                                        Address Line 1: {profile?.addressLine1}{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        Address Line 2: {profile?.addressLine2}{" "}
                                    </p>
                                }
                                {<p>City: {profile?.city} </p>}
                                {<p>State: {profile?.state} </p>}
                                {<p>Zipcode: {profile?.zipcode} </p>}
                                {
                                    <p>
                                        Navajo Tribe Member:{" "}
                                        {profile?.navajoTribeMember}{" "}
                                    </p>
                                }
                                {<p>Census: {profile?.census} </p>}
                                {<p>Nationality: {profile?.nationality} </p>}
                                {
                                    <p>
                                        Has Driver License:{" "}
                                        {profile?.hasDriverLicense}{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        Driver License Number:{" "}
                                        {profile?.driverLicenseNumber}{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        Driver License Class:{" "}
                                        {profile?.driverLicenseClass}{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        Driver License State:{" "}
                                        {profile?.driverLicenseState}{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        Driver License Expiration Date:{" "}
                                        {profile?.driverLicenseExpirationDate}{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        Driver License Type:{" "}
                                        {profile?.driverLicenseType}{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        Attended High School:{" "}
                                        {profile?.attendedHighSchool}{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        High School Name:{" "}
                                        {profile?.highSchoolName}{" "}
                                    </p>
                                }
                                {<p>Education: {profile?.education} </p>}
                                {
                                    <p>
                                        High School Address:{" "}
                                        {profile?.highSchoolAddress}{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        High School Start:{" "}
                                        {profile?.highSchoolStart}{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        High School End:{" "}
                                        {profile?.highSchoolEnd}{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        Currently Employed:{" "}
                                        {profile?.currentlyEmployed}{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        Attended College 1:{" "}
                                        {profile?.attendedCollege1}{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        College Name 1: {profile?.collegeName1}{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        College Address 1:{" "}
                                        {profile?.collegeAddress1}{" "}
                                    </p>
                                }
                                {<p>Degree 1: {profile?.degree1} </p>}
                                {<p>Major 1: {profile?.major1} </p>}
                                {<p>Minor 1: {profile?.minor1} </p>}
                                {
                                    <p>
                                        College Start 1:{" "}
                                        {profile?.collegeStart1}{" "}
                                    </p>
                                }
                                {<p>College End 1: {profile?.collegeEnd1} </p>}
                                {
                                    <p>
                                        College Credit Hours 1:{" "}
                                        {profile?.collegeCreditHours1}{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        Attended College 2:{" "}
                                        {profile?.attendedCollege2}{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        College Name 2: {profile?.collegeName2}{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        College Address 2:{" "}
                                        {profile?.collegeAddress2}{" "}
                                    </p>
                                }
                                {<p>Degree 2: {profile?.degree2} </p>}
                                {<p>Major 2: {profile?.major2} </p>}
                                {<p>Minor 2: {profile?.minor2} </p>}
                                {
                                    <p>
                                        College Start 2:{" "}
                                        {profile?.collegeStart2}{" "}
                                    </p>
                                }
                                {<p>College End 2: {profile?.collegeEnd2} </p>}
                                {
                                    <p>
                                        College Credit Hours 2:{" "}
                                        {profile?.collegeCreditHours2}{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        Attended Technical School:{" "}
                                        {profile?.attendedTechSchool}{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        Technical School Name 1:{" "}
                                        {profile?.techSchoolName1}{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        Technical School Address 1:{" "}
                                        {profile?.techSchoolAddress1}{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        Technical Degree 1:{" "}
                                        {profile?.techDegree1}{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        Technical Major 1: {profile?.techMajor1}{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        Technical Minor 1: {profile?.techMinor1}{" "}
                                    </p>
                                }
                                {<p>Tech Start 1: {profile?.techStart1} </p>}
                                {<p>Tech End 1: {profile?.techEnd1} </p>}
                                {
                                    <p>
                                        Tech Credit Hour 1:{" "}
                                        {profile?.techCreditHours1}{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        Training Name 1:{" "}
                                        {profile?.trainingName1}{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        Training Start 1:{" "}
                                        {profile?.trainingStart1}{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        Training End 1: {profile?.trainingEnd1}{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        Training Name 2:{" "}
                                        {profile?.trainingName2}{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        Training Start 2:{" "}
                                        {profile?.trainingStart2}{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        Training End 2: {profile?.trainingEnd2}{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        Training Name 3:{" "}
                                        {profile?.trainingName3}{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        Training Start 3:{" "}
                                        {profile?.trainingStart3}{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        Training End 3: {profile?.trainingEnd3}{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        Training Name 4:{" "}
                                        {profile?.trainingName4}{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        Training Start 4:{" "}
                                        {profile?.trainingStart4}{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        Training End 4: {profile?.trainingEnd4}{" "}
                                    </p>
                                }
                                {<p>Skill Name 1: {profile?.skillName1} </p>}
                                {<p>Skill Name 2: {profile?.skillName2} </p>}
                                {<p>Skill Name 3: {profile?.skillName3} </p>}
                                {<p>Skill Name 4: {profile?.skillName4} </p>}
                                {<p>Felony: {profile?.felony} </p>}
                                {<p>Felony Date: {profile?.felonyDate} </p>}
                                {<p>Felony Reason: {profile?.felonyReason} </p>}
                                {<p>Misdemeanor: {profile?.misdemeanor} </p>}
                                {
                                    <p>
                                        Misdemeanor Date:{" "}
                                        {profile?.misdemeanorDate}{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        Misdemeanor Reason:{" "}
                                        {profile?.misdemeanorReason}{" "}
                                    </p>
                                }
                                {<p>Physical: {profile?.physical} </p>}
                                {
                                    <p>
                                        Physical Name 1:{" "}
                                        {profile?.physicalName1}{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        Physical Reason 1:{" "}
                                        {profile?.physicalReason1}{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        Physical Name 2:{" "}
                                        {profile?.physicalName2}{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        Physical Reason 2:{" "}
                                        {profile?.physicalReason2}{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        Physical Name 3:{" "}
                                        {profile?.physicalName3}{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        Physical Reason 3:{" "}
                                        {profile?.physicalReason3}{" "}
                                    </p>
                                }
                                {<p>Relations: {profile?.relations} </p>}
                                {
                                    <p>
                                        Relations Relationship 1:{" "}
                                        {profile?.relationsRelationship1}{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        Relations Name 1:{" "}
                                        {profile?.relationsName1}{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        Relations Department 1:{" "}
                                        {profile?.relationsDepartment1}{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        Relations Relationship 2:{" "}
                                        {profile?.relationsRelationship2}{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        Relations Name 2:{" "}
                                        {profile?.relationsName2}{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        Relations Department 2:{" "}
                                        {profile?.relationsDepartment2}{" "}
                                    </p>
                                }
                                {<p>Employer 1: {profile?.employer1} </p>}
                                {
                                    <p>
                                        Employer Address 1:{" "}
                                        {profile?.employerAddress1}{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        Employer Start 1:{" "}
                                        {profile?.employerStart1}{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        Employer End 1: {profile?.employerEnd1}{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        Employer Supervisor 1:{" "}
                                        {profile?.employerSupervisor1}{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        Employer Job Title 1:{" "}
                                        {profile?.employerJobTitle1}{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        Employer Phone 1:{" "}
                                        {profile?.employerPhone1}{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        Employer Reason 1:{" "}
                                        {profile?.employerReason1}{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        Employer Duties 1:{" "}
                                        {profile?.employerDuties1}{" "}
                                    </p>
                                }
                                {<p>Employer 2: {profile?.employer2} </p>}
                                {
                                    <p>
                                        Employer Address 2:{" "}
                                        {profile?.employerAddress2}{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        Employer Start 2:{" "}
                                        {profile?.employerStart2}{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        Employer End 2: {profile?.employerEnd2}{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        Employer Supervisor 2:{" "}
                                        {profile?.employerSupervisor2}{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        Employer Job Title 2:{" "}
                                        {profile?.employerJobTitle2}{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        Employer Phone 2:{" "}
                                        {profile?.employerPhone2}{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        Employer Reason 2:{" "}
                                        {profile?.employerReason2}{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        Employer Duties 2:{" "}
                                        {profile?.employerDuties2}{" "}
                                    </p>
                                }
                                {<p>Employer 3: {profile?.employer3} </p>}
                                {
                                    <p>
                                        Employer Address 3:{" "}
                                        {profile?.employerAddress3}{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        Employer Start 3:{" "}
                                        {profile?.employerStart3}{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        Employer End 3: {profile?.employerEnd3}{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        Employer Supervisor 3:{" "}
                                        {profile?.employerSupervisor3}{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        Employer Job Title 3:{" "}
                                        {profile?.employerJobTitle3}{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        Employer Phone 3:{" "}
                                        {profile?.employerPhone3}{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        Employer Reason 3:{" "}
                                        {profile?.employerReason3}{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        Employer Duties 3:{" "}
                                        {profile?.employerDuties3}{" "}
                                    </p>
                                }
                                {<p>Employer 4: {profile?.employer4} </p>}
                                {
                                    <p>
                                        Employer Address 4:{" "}
                                        {profile?.employerAddress4}{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        Employer Start 4:{" "}
                                        {profile?.employerStart4}{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        Employer End 4: {profile?.employerEnd4}{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        Employer Supervisor 4:{" "}
                                        {profile?.employerSupervisor4}{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        Employer Job Title 4:{" "}
                                        {profile?.employerJobTitle4}{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        Employer Phone 4:{" "}
                                        {profile?.employerPhone4}{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        Employer Reason 4:{" "}
                                        {profile?.employerReason4}{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        Employer Duties 4:{" "}
                                        {profile?.employerDuties4}{" "}
                                    </p>
                                }
                                {<p>Employer 5: {profile?.employer5} </p>}
                                {
                                    <p>
                                        Employer Address 5:{" "}
                                        {profile?.employerAddress5}{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        Employer Start 5:{" "}
                                        {profile?.employerStart5}{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        Employer End 5: {profile?.employerEnd5}{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        Employer Supervisor 5:{" "}
                                        {profile?.employerSupervisor5}{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        Employer Job Title 5:{" "}
                                        {profile?.employerJobTitle5}{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        Employer Phone 5:{" "}
                                        {profile?.employerPhone5}{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        Employer Reason 5:{" "}
                                        {profile?.employerReason5}{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        Employer Duties 5:{" "}
                                        {profile?.employerDuties5}{" "}
                                    </p>
                                }
                                {<p>Employer 6: {profile?.employer6} </p>}
                                {
                                    <p>
                                        Employer Address 6:{" "}
                                        {profile?.employerAddress6}{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        Employer Start 6:{" "}
                                        {profile?.employerStart6}{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        Employer End 6: {profile?.employerEnd6}{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        Employer Supervisor 6:{" "}
                                        {profile?.employerSupervisor6}{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        Employer Job Title 6:{" "}
                                        {profile?.employerJobTitle6}{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        Employer Phone 6:{" "}
                                        {profile?.employerPhone6}{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        Employer Reason 6:{" "}
                                        {profile?.employerReason6}{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        Employer Duties 6:{" "}
                                        {profile?.employerDuties6}{" "}
                                    </p>
                                }

                                {<p>rif Date: {profile?.rifDate} </p>}
                                {<p>rif: {profile?.rif} </p>}
                                {<p>Veteran: {profile?.veteran} </p>}
                                {<p>DD 214 On File: {profile?.DD214OnFile} </p>}
                                {<p>NN Spouse: {profile?.NN_Spouse} </p>}
                                {
                                    <p>
                                        NN Spouse Affividavit:{" "}
                                        {profile?.NN_SpouseAffividavit}{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        NN Spouse PrefEligible:{" "}
                                        {profile?.NN_SpousePrefEligible}{" "}
                                    </p>
                                }
                                {<p>NN Spouse CIB: {profile?.NN_SpouseCIB} </p>}
                                {
                                    <p>
                                        NN Spouse License:{" "}
                                        {profile?.NN_SpouseLicense}{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        NN Spouse Census:{" "}
                                        {profile?.NN_SpouseCensus}{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        Veteran DD214 Form Original Name:{" "}
                                        {
                                            profile?.Veteran_DD214Form_OriginalName
                                        }{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        Veteran DD214 Form UploadDate:{" "}
                                        {profile?.Veteran_DD214Form_UploadDate}{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        Veteran DD214Form FileSize:{" "}
                                        {profile?.Veteran_DD214Form_FileSize}{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        RIF Form Original Name:{" "}
                                        {profile?.RIF_Form_OriginalName}{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        RIF Form UploadDate:{" "}
                                        {profile?.RIF_Form_UploadDate}{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        RIF Form FileSize:{" "}
                                        {profile?.RIF_Form_FileSize}{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        NN CIB Form Original Name:{" "}
                                        {profile?.NN_CIBForm_OriginalName}{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        NN CIB Form UploadDate:{" "}
                                        {profile?.NN_CIBForm_UploadDate}{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        NN CIB Form FileSize:{" "}
                                        {profile?.NN_CIBForm_FileSize}{" "}
                                    </p>
                                }

                                {
                                    <p>
                                        Veteran Preference Application Form
                                        Original Name:{" "}
                                        {
                                            profile?.Veteran_Preference_ApplicationForm_OriginalName
                                        }{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        Veteran Preference Application Form
                                        Upload Date:{" "}
                                        {
                                            profile?.Veteran_Preference_ApplicationForm_UploadDate
                                        }{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        Veteran Preference Application Form
                                        FileSize:{" "}
                                        {
                                            profile?.Veteran_Preference_ApplicationForm_FileSize
                                        }{" "}
                                    </p>
                                }

                                {
                                    <p>
                                        NN Spouse CIB Form Original Name:{" "}
                                        {profile?.NN_SpouseCIBForm_OriginalName}{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        NN Spouse CIB Form Upload Date:{" "}
                                        {profile?.NN_SpouseCIBForm_UploadDate}{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        NN Spouse CIB Form File Size:{" "}
                                        {profile?.NN_SpouseCIBForm_FileSize}{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        NN Spouse Marriage License Form Original
                                        Name:{" "}
                                        {
                                            profile?.NN_SpouseMarriageLicenseForm_OriginalName
                                        }{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        NN Spouse Marriage License Form Upload
                                        Date:{" "}
                                        {
                                            profile?.NN_SpouseMarriageLicenseForm_UploadDate
                                        }{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        NN Spouse Marriage License Form
                                        FileSize:{" "}
                                        {
                                            profile?.NN_SpouseMarriageLicenseForm_FileSize
                                        }{" "}
                                    </p>
                                }

                                {
                                    <p>
                                        NN Spouse Residence Verification Form
                                        OriginalName:{" "}
                                        {
                                            profile?.NN_Spouse_ResidenceVerificationForm_OriginalName
                                        }{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        NN Spouse Residence Verification Form
                                        UploadDate:{" "}
                                        {
                                            profile?.NN_Spouse_ResidenceVerificationForm_UploadDate
                                        }{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        NN Spouse Residence Verification Form
                                        FileSize:{" "}
                                        {
                                            profile?.NN_Spouse_ResidenceVerificationForm_FileSize
                                        }{" "}
                                    </p>
                                }

                                {
                                    <p>
                                        Additional Info Field 1 OriginalName:{" "}
                                        {
                                            profile?.Additional_Info_Field_1_OriginalName
                                        }{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        Additional Info Field 1 UploadDate:{" "}
                                        {
                                            profile?.Additional_Info_Field_1_UploadDate
                                        }{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        Additional Info Field 1 FileSize:{" "}
                                        {
                                            profile?.Additional_Info_Field_1_FileSize
                                        }{" "}
                                    </p>
                                }

                                {
                                    <p>
                                        Additional Info Field 2 OriginalName:{" "}
                                        {
                                            profile?.Additional_Info_Field_2_OriginalName
                                        }{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        Additional Info Field 2 UploadDate:{" "}
                                        {
                                            profile?.Additional_Info_Field_2_UploadDate
                                        }{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        Additional Info Field 2 FileSize:{" "}
                                        {
                                            profile?.Additional_Info_Field_2_FileSize
                                        }{" "}
                                    </p>
                                }

                                {
                                    <p>
                                        Additional Info Field 3 OriginalName:{" "}
                                        {
                                            profile?.Additional_Info_Field_3_OriginalName
                                        }{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        Additional Info Field 3 UploadDate:{" "}
                                        {
                                            profile?.Additional_Info_Field_3_UploadDate
                                        }{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        Additional Info Field 3 FileSize:{" "}
                                        {
                                            profile?.Additional_Info_Field_3_FileSize
                                        }{" "}
                                    </p>
                                }

                                {
                                    <p>
                                        Additional Info Field 4 OriginalName:{" "}
                                        {
                                            profile?.Additional_Info_Field_4_OriginalName
                                        }{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        Additional Info Field 4 UploadDate:{" "}
                                        {
                                            profile?.Additional_Info_Field_4_UploadDate
                                        }{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        Additional Info Field 4 FileSize:{" "}
                                        {
                                            profile?.Additional_Info_Field_4_FileSize
                                        }{" "}
                                    </p>
                                }

                                {
                                    <p>
                                        Additional Info Field 5 OriginalName:{" "}
                                        {
                                            profile?.Additional_Info_Field_5_OriginalName
                                        }{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        Additional Info Field 5 UploadDate:{" "}
                                        {
                                            profile?.Additional_Info_Field_5_UploadDate
                                        }{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        Additional Info Field 5 FileSize:{" "}
                                        {
                                            profile?.Additional_Info_Field_5_FileSize
                                        }{" "}
                                    </p>
                                }

                                {
                                    <p>
                                        Additional Info Field 6 OriginalName:{" "}
                                        {
                                            profile?.Additional_Info_Field_6_OriginalName
                                        }{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        Additional Info Field 6 UploadDate:{" "}
                                        {
                                            profile?.Additional_Info_Field_6_UploadDate
                                        }{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        Additional Info Field 6 FileSize:{" "}
                                        {
                                            profile?.Additional_Info_Field_6_FileSize
                                        }{" "}
                                    </p>
                                }

                                {
                                    <p>
                                        HS Form OriginalName:{" "}
                                        {profile?.HS_Form_OriginalName}{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        HS Form UploadDate:{" "}
                                        {profile?.HS_Form_UploadDate}{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        HS Form FileSize:{" "}
                                        {profile?.HS_Form_FileSize}{" "}
                                    </p>
                                }

                                {
                                    <p>
                                        College 1 Form Original Name:{" "}
                                        {profile?.College1_Form_OriginalName}{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        College 1 Form UploadDate:{" "}
                                        {profile?.College1_Form_UploadDate}{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        College1 Form FileSize:{" "}
                                        {profile?.College1_Form_FileSize}{" "}
                                    </p>
                                }

                                {
                                    <p>
                                        College 2 Form Original Name:{" "}
                                        {profile?.College2_Form_OriginalName}{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        College 2 Form UploadDate:{" "}
                                        {profile?.College2_Form_UploadDate}{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        College 2 Form FileSize:{" "}
                                        {profile?.College2_Form_FileSize}{" "}
                                    </p>
                                }

                                {
                                    <p>
                                        Schools Form OriginalName:{" "}
                                        {profile?.Schools_Form_OriginalName}{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        Schools Form UploadDate:{" "}
                                        {profile?.Schools_Form_UploadDate}{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        Schools Form FileSize:{" "}
                                        {profile?.Schools_Form_FileSize}{" "}
                                    </p>
                                }

                                 application
                                <h3>Application</h3>

                                {
                                    <p>
                                        App Date Recd:{" "}
                                        {application?.App_Date_Recd}{" "}
                                    </p>
                                }
                                {<p>App REQID: {application?.App_REQID} </p>}
                                {
                                    <p>
                                        Position Number:{" "}
                                        {application?.PositionNumber}{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        Position Title:{" "}
                                        {application?.PositionTitle}{" "}
                                    </p>
                                }
                                {<p>Location: {application?.Location} </p>}
                                {
                                    <p>
                                        Closing Date: {application?.ClosingDate}{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        Submission Date:{" "}
                                        {application?.SubmissionDate}{" "}
                                    </p>
                                }
                                {<p>App Status: {application?.App_Status} </p>}
                                {
                                    <p>
                                        App Work Hours:{" "}
                                        {application?.App_WorkHours}{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        App Work Days:{" "}
                                        {application?.App_WorkDays}{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        App Pay Rate: {application?.App_PayRate}{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        App Employment Type:{" "}
                                        {application?.App_EmploymentType}{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        App Sensitive:{" "}
                                        {application?.App_Sensitive}{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        App Department:{" "}
                                        {application?.App_Department}{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        App Location:{" "}
                                        {application?.App_Location}{" "}
                                    </p>
                                }
                                {<p>Skills 1: {application?.Skills1} </p>}
                                {<p>Skills 2: {application?.Skills2} </p>}
                                {<p>Skills 3: {application?.Skills3} </p>}
                                {<p>Skills 4: {application?.Skills4} </p>}
                                {
                                    <p>
                                        Trainings 1 Expiration Date:{" "}
                                        {application?.Trainings1_ExpirationDate}{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        Trainings 1 From:{" "}
                                        {application?.Trainings1_From}{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        Trainings 1 Name:{" "}
                                        {application?.Trainings1_Name}{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        Trainings 1 To:{" "}
                                        {application?.Trainings1_To}{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        Trainings 2 Expiration Date:{" "}
                                        {application?.Trainings2_ExpirationDate}{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        Trainings 2 From:{" "}
                                        {application?.Trainings2_From}{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        Trainings 2 Name:{" "}
                                        {application?.Trainings2_Name}{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        Trainings 2 To:{" "}
                                        {application?.Trainings2_To}{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        Trainings 3 Expiration Date:{" "}
                                        {application?.Trainings3_ExpirationDate}{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        Trainings 3 From:{" "}
                                        {application?.Trainings3_From}{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        Trainings 3 Name:{" "}
                                        {application?.Trainings3_Name}{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        Trainings 3 To:{" "}
                                        {application?.Trainings3_To}{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        Trainings 4 Expiration Date:{" "}
                                        {application?.Trainings4_ExpirationDate}{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        Trainings 4 From:{" "}
                                        {application?.Trainings4_From}{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        Trainings 4 Name:{" "}
                                        {application?.Trainings4_Name}{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        Trainings 4 To:{" "}
                                        {application?.Trainings4_To}{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        Trainings 5 Expiration Date:{" "}
                                        {application?.Trainings5_ExpirationDate}{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        Trainings 5 From:{" "}
                                        {application?.Trainings5_From}{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        Trainings 5 Name:{" "}
                                        {application?.Trainings5_Name}{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        Trainings 5 To:{" "}
                                        {application?.Trainings5_To}{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        Trainings 6 Expiration Date:{" "}
                                        {application?.Trainings6_ExpirationDate}{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        Trainings 6 From:{" "}
                                        {application?.Trainings6_From}{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        Trainings 6 Name:{" "}
                                        {application?.Trainings6_Name}{" "}
                                    </p>
                                }
                                {
                                    <p>
                                        Trainings 6 To:{" "}
                                        {application?.Trainings6_To}{" "}
                                    </p>
                                }*/}
                                </Card.Body>
                            </Card>
                        </div>
                    </Col>
                </Row>
            </Container>
        </>
    );
};
